import React, { createContext } from 'react';
import { createViewerConfig, createViewerProvider, createUseViewers } from './ViewerContext.js';

// Create a separate context for document viewers
const DocumentViewerContext = createContext();

// Create configuration for document viewers
export const documentViewerConfig = createViewerConfig({
  itemType: 'document',
  fetchAllViewers: (insightsService) => insightsService.fetchAllDocumentViewers(),
  addViewerUpdateCallback: (notificationManager, callback) => 
    notificationManager.addDocumentViewerUpdateCallback(callback)
});

// Create DocumentViewerProvider component with its own context
export const DocumentViewerProvider = createViewerProvider(DocumentViewerContext, documentViewerConfig);

// Create useDocumentViewers hook with its own context
export const useDocumentViewers = createUseViewers(DocumentViewerContext, 'document');
